export default __webpack_public_path__ + "static/media/threeDots.5089a80d.svg";